// extracted by mini-css-extract-plugin
module.exports = {"searchResults":"_2kN_lbbtULK-viAHwWB3_J","results":"_2k5KeW_ZTwDe745fXgemYL","delete":"_1_oPf3kcVK2f6bXNLEc4iW"};